module.exports = {"name":"autoWatch","meta":{"description":"Auto watch new cards and on adding/changing due dates","link":"https://trello.com/c/UnEQfHVE/329-auto-watch-cards-a-user-creates"},"audiences":["allMembers"],"experimentAllocation":0.3,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"dueDate","weight":1},{"name":"newCard","weight":1}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/autoWatch.json
// module id = s/LT
// module chunks = 12